// extracted by mini-css-extract-plugin
module.exports = {"tab_bgremover":"patients_tab_bgremover__gMx1L","patient_loader":"patients_patient_loader__1nQqO"};